
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.833 8.333a.834.834 0 111.668 0 .834.834 0 01-1.668 0zM10 7.5a.834.834 0 100 1.667.834.834 0 000-1.667zm3.333 0a.834.834 0 10.001 1.667.834.834 0 000-1.667zm3.334 5c0 .459-.374.833-.834.833H7.128c-.452 0-.897.123-1.286.357l-2.509 1.505V4.166c0-.459.375-.833.834-.833h11.666c.46 0 .834.374.834.833V12.5zm-.834-10.834H4.167a2.503 2.503 0 00-2.5 2.5v12.5a.833.833 0 001.262.715l3.77-2.262a.831.831 0 01.43-.12h8.704c1.379 0 2.5-1.12 2.5-2.5V4.167c0-1.378-1.121-2.5-2.5-2.5z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.833 8.333a.834.834 0 111.668 0 .834.834 0 01-1.668 0zM10 7.5a.834.834 0 100 1.667.834.834 0 000-1.667zm3.333 0a.834.834 0 10.001 1.667.834.834 0 000-1.667zm3.334 5c0 .459-.374.833-.834.833H7.128c-.452 0-.897.123-1.286.357l-2.509 1.505V4.166c0-.459.375-.833.834-.833h11.666c.46 0 .834.374.834.833V12.5zm-.834-10.834H4.167a2.503 2.503 0 00-2.5 2.5v12.5a.833.833 0 001.262.715l3.77-2.262a.831.831 0 01.43-.12h8.704c1.379 0 2.5-1.12 2.5-2.5V4.167c0-1.378-1.121-2.5-2.5-2.5z"}})])
          )
        }
      }
    